// modifer: styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionCommentsStyle
import { warningColor, defaultFont } from 'styles/jss/original/base';

import tooltipsStyle from 'styles/jss/nextjs-material-kit-pro/tooltipsStyle.js';

const styles = {
  ...tooltipsStyle,
  footerButtons: {
    float: 'right',
    padding: '0',
    marginRight: '5px'
  },
  user: {
    ...defaultFont,
    fontWeight: '700'
  },
  date: {
    paddingLeft: '8px',
    fontWeight: '300'
  },
  good: {
    display: 'flex',
    padding: '0px',
    width: 'auto',
    alignItems: 'baseline',
    justifyContent: 'flex-end'
  },
  goodText: {
    fontSize: '14px',
    marginRight: '5px'
  },
  goodCount: {
    fontSize: '14px'
  },
  message: {
    '& a': {
      color: warningColor[0],
      textDecoration: 'underline'
    }
  }
};

export default styles;
